import React from 'react'
import { Navigate, Route, Routes } from 'react-router-dom'
import { InProgressPage } from '../InProgress/InProgress'
import UsersOfSuborganization from './Users/Users'
import { SuborganizationStorageStatus } from '../Storage/SuborganizationStatus/SuborganizationStorageStatus'

export const Suborganization = () => {
  return (
    <Routes>
      <Route path="/" element={<InProgressPage />} />
      <Route path=":id/users" element={<UsersOfSuborganization />} />
      <Route
        path=":id/statusStorage"
        element={<SuborganizationStorageStatus />}
      />
      <Route path="*" element={<Navigate replace to="/home" />} />
    </Routes>
  )
}
